BrandCtrl.$inject = ["$window", "brandService"];

/* @ngInject */
function BrandCtrl($window, brandService) {
  var ctrl = this;

  ctrl.changeCountyId = function (curSort,
  /*GlorySoft_034*/
  segment) {
    brandService.filterRefresh(brandService.buildUrlParams($window.location.search, 'countryId', curSort),
    /*GlorySoft_034*/
    segment);
  };

  ctrl.changeLetter = function (curLetter,
  /*GlorySoft_034*/
  segment) {
    brandService.filterRefresh(brandService.buildUrlParams($window.location.search, 'letter', curLetter),
    /*GlorySoft_034*/
    segment);
  };

  ctrl.changeBrandname = function (event, curName,
  /*GlorySoft_034*/
  segment) {
    if (curName != null && (event.type == 'keypress' && event.keyCode == 13 || event.type == 'click')) {
      brandService.filterRefresh(brandService.buildUrlParams($window.location.search, 'q', curName),
      /*GlorySoft_034*/
      segment);
    }
  };
}

;
export default BrandCtrl;